export default __webpack_public_path__ + "media/InteractiveGaming.75dc59b1.svg";